export default class verificaForcaSenha {
    constructor(id_input) {
        this.numeros = /([0-9])/;
        this.alfabeto = /([a-zA-Z])/;
        this.chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<,.,])/;
        this.maiusculas = /([A-Z])/;
        this.id_input = (id_input === 'nm_senha') ? 'password-status' : 'password-status-altera';
    }

    verificaSenhaCadastro(senha) {
        const spanDescSenha = document.getElementById(`${this.id_input}`);
        if (spanDescSenha) {
            if (!senha) {
                spanDescSenha.innerHTML = '';
                spanDescSenha.style.color = '#929292';
                return false;
            } else if (senha.length < 6) {
                spanDescSenha.innerHTML = 'Senha fraca, insira no mínimo 6 caracteres';
                spanDescSenha.style.color = 'darkred';
                return false;
            } else {
                if (senha.match(this.numeros) && senha.match(this.alfabeto) && senha.match(this.chEspeciais) && senha.match(this.maiusculas)) {
                    spanDescSenha.innerHTML = 'Senha forte';
                    spanDescSenha.style.color = '#4353ff';
                    return true;
                } else {
                    spanDescSenha.innerHTML = 'Senha média. Senhas fortes têm letras, números e caracteres especiais.';
                    spanDescSenha.style.color = 'darkorange';
                    return false;
                }
            }
        }
    }
}
